import styled from 'styled-components';

import { Content as ThemeContent } from '../../../../theme/layout';
import { paragraph, inlineLink } from '../../../../theme/typography';
import { SnackbarContainer } from '../snackbarRender.styles';
import { themeColor, themeColorWithOpacity } from '../../../../theme/getters';

export const Container = styled(SnackbarContainer)``;

export const Content = styled(ThemeContent)`
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: space-between;
  align-items: center;

  ${paragraph};
  color: ${themeColor('white')};
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Text = styled.p`
  margin-left: 20px;
`;

export const EndSession = styled.span`
  display: inline;
  margin: 0;

  ${inlineLink};
  ${paragraph};

  color: ${themeColor('white')};
  text-decoration-color: ${themeColorWithOpacity('white', 0.2)};
`;
